
import 'photoswipe/dist/photoswipe.css'

import { faPawSimple } from '@fortawesome/pro-solid-svg-icons'
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.min.js'

export default {
  name: 'PaddockSingle',

  props: {
    paddock: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      lightbox: null,
      faPawSimple
    }
  },

  head() {
    return {
      title: this.paddock?.name
    }
  },

  computed: {
    compOpeningHours() {
      return this.paddock.openingHours.months[this.$dateNew.now().month - 1].daysOfWeek
    },

    compFacilities() {
      const availableFacilities = this.paddock.facilities.split(',')

      const facilities = [
        {
          label: 'Running water',
          imageUrl: require('~/assets/images/icons/facilities/water.png'),
          isActive: availableFacilities.includes('water')
        },
        {
          label: 'Agility obstacle',
          imageUrl: require('~/assets/images/icons/facilities/agility.png'),
          isActive: availableFacilities.includes('agility')
        },
        {
          label: 'Solid paths',
          imageUrl: require('~/assets/images/icons/facilities/paths.png'),
          isActive: availableFacilities.includes('paths')
        },
        {
          label: 'Dog wash',
          imageUrl: require('~/assets/images/icons/facilities/dog-wash.png'),
          isActive: this.paddock.hasDogWash
        },
        {
          label: 'Field shelter',
          imageUrl: require('~/assets/images/icons/facilities/field-shelter.png'),
          isActive: availableFacilities.includes('shelter')
        },
        {
          label: 'Field size (acres)'
        },
        {
          label: 'Maximum dogs'
        }
      ]

      return facilities.filter(facility => facility.isActive !== false)
    },

    paddockImages() {
      return this.paddock.media?.length > 0
        ? this.paddock.media.map(image => ({
            id: image.id,
            smallImageUrl: `${image.publicUrl}?width=500`,
            largeImageUrl: `${image.publicUrl}?width=1200&height=829`
          }))
        : []
    }
  },

  mounted() {
    this.setupGallery()

    setTimeout(() => {
      this.$analytics.addEvent('Paddock view', {
        id: this.paddock.id,
        name: this.paddock.name
      })
    }, 1000)
  },

  unmounted() {
    if (this.lightbox) {
      this.lightbox.destroy()
      this.lightbox = null
    }
  },

  created() {
    this.$store.dispatch('paddocks/fetchAll')
  },

  methods: {
    async setupGallery() {
      await this.$elementReady.selector('#gallery')

      if (!this.lightbox) {
        this.lightbox = new PhotoSwipeLightbox({
          gallery: `#gallery`,
          children: 'a',
          pswpModule: () => import('photoswipe/dist/photoswipe.esm.min.js')
        })

        this.lightbox.init()
      }
    },

    findOutMorePaddock(paddock) {
      this.$emit('findOutMore', paddock)
    },

    viewAllPaddocks() {
      this.$emit('viewAllPaddocks')
    },

    startBooking() {
      this.$emit('book', this.paddock)
    }
  }
}
